// frontend/src/components/AdminTeamDetail/LightboxModal.js
import React from 'react';

// Helper to get full-size URL for Sportradar images
const getFullSizeUrl = (url) => {
    if (!url) return url;
    // If it's a Sportradar image URL, ensure we use RAW size
    if (url.includes('sportradar.com') || url.includes('sportradar.us')) {
        // Remove any existing size params and add RAW
        const baseUrl = url.split('?')[0];
        return `${baseUrl}?size=RAW&format=webp`;
    }
    return url;
};

const LightboxModal = ({ show, image, onClose }) => {
    if (!show || !image) return null;

    // Prefer sportradar_photo_url for full-size, fallback to photo_url
    const displayUrl = getFullSizeUrl(image.sportradar_photo_url || image.photo_url);

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
            onClick={onClose}
        >
            <div className="relative max-w-6xl max-h-full">
                <img
                    src={displayUrl}
                    alt={image.player_name}
                    className="max-w-full max-h-[90vh] object-contain"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-4">
                    <p className="text-lg font-semibold">{image.player_name}</p>
                </div>
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-white hover:text-gray-300"
                >
                    <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default LightboxModal;
